import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';

@Component({
  selector: 'tog-app-preview-container',
  templateUrl: './app-preview-container.component.html',
  styleUrls: ['./app-preview-container.component.scss']
})
export class AppPreviewContainerComponent implements OnInit {
  container: Element;
  previewContainer: Element;
  containerWrapper: Element;
  left: number;
  constructor() { }

  ngOnInit() {
    let self = this;

    this.container = document.getElementsByClassName('tog-root-content')[0];
    this.previewContainer = document.getElementsByClassName('app-preview-container')[0];
    this.containerWrapper = document.getElementsByClassName("container-wrapper")[0];

    let boundingRect;
    if(this.containerWrapper) {
      boundingRect = this.containerWrapper.getBoundingClientRect();
      this.left = boundingRect.width + boundingRect.left - this.previewContainer.clientWidth;
    }
  }

  @HostListener('window:resize')
  adjustPosition() {
    if (this.containerWrapper) {
      let boundingRect = this.containerWrapper.getBoundingClientRect();
      this.left = boundingRect.width + boundingRect.left - this.previewContainer.clientWidth;
    }
  }

  disablePageScroll() {
    let root = document.getElementsByClassName('tog-root-content');
    if (root.length) {
      (<any>root[0]).style.paddingRight = this.calculateScrollbarWidth() + 'px';
      root[0].classList.add('hover-active');
    }
  }

  enablePageScroll() {
    let root = document.getElementsByClassName('tog-root-content');
    if (root.length) {
      (<any>root[0]).style.paddingRight = '0';
      root[0].classList.remove('hover-active');
    }
  }

  // From https://stackoverflow.com/questions/13382516/getting-scroll-bar-width-using-javascript
  calculateScrollbarWidth() {
    var outer = document.createElement("div");
    outer.style.visibility = "hidden";
    outer.style.width = "100px";
    outer.style.msOverflowStyle = "scrollbar"; // needed for WinJS apps

    document.body.appendChild(outer);

    var widthNoScroll = outer.offsetWidth;

    // force scrollbars
    outer.style.overflow = "scroll";

    // add innerdiv
    var inner = document.createElement("div");
    inner.style.width = "100%";
    outer.appendChild(inner);

    var widthWithScroll = inner.offsetWidth;

    // remove divs
    outer.parentNode.removeChild(outer);

    return widthNoScroll - widthWithScroll;
  }
}



// WEBPACK FOOTER //
// /app/src/app/shared/components/app-preview-container/app-preview-container.component.ts